import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { PURGE } from "redux-persist";
import apiInstance from '../../../../api';

export const getCorpClientReport = createAsyncThunk(
  'accountingReports/getCorpClientReport',
  async (data, { rejectWithValue }) => {
    const api = `/reports/getCorporateClientReportV${data.version || 1}?XDEBUG_SESSION_START=MyVSCode`;

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }), {
        responseType: 'blob'
      });

      if (response.data) {
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        
        return blob;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const getSalesReportByCorp = createAsyncThunk(
  'accountingReports/getSalesReportByCorp',
  async (data, { rejectWithValue }) => {
    const api = `/reports/getCorporateSalesReportV${data.version || 1}?XDEBUG_SESSION_START=MyVSCode`;

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }), {
        responseType: 'blob'
      });

      if (response.data) {
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        
        return blob;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const getSalesReportByFiz = createAsyncThunk(
  'accountingReports/getSalesReportByFiz',
  async (data, { rejectWithValue }) => {
    const api = `/reports/getIndividualSalesReportV${data.version || 1}?XDEBUG_SESSION_START=MyVSCode`;

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }), {
        responseType: 'blob'
      });

      if (response.data) {
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        
        return blob;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const getOldKitchenTaxReport = createAsyncThunk(
  'accountingReports/getKitchenTaxReport',
  async (data, { rejectWithValue }) => {
    const api = `/reports/getKitchenSalesAndCommissionReport?XDEBUG_SESSION_START=MyVSCode`;

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }), {
        responseType: 'blob'
      });

      if (response.data) {
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        
        return blob;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const getKitchenTaxReport = createAsyncThunk(
  'accountingReports/getKitchenTaxReport',
  async (data, { rejectWithValue }) => {
    const api = `/reports/getKitchenSalesAndCommissionReportv${data.version || 1}?XDEBUG_SESSION_START=MyVSCode`;

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }), {
        responseType: 'blob'
      });

      if (response.data) {
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        
        return blob;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const getSummarySales = createAsyncThunk(
  'accountingReports/getSummarySales',
  async (data, { rejectWithValue }) => {
    const api = '/reports/getSummarySales?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return {
          date: data.deliveryDay,
          timestamp: Date.now(),
          data: response.data.data
        };
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

const initialState = {
  getCorpClientReportStatus: null,
  getSalesReportByCorpStatus: null,
  getSalesReportByFizStatus: null,
  getKitchenTaxReportStatus: null,
  getSummarySalesStatus: null,
  summarySales: [],
};

const accountingReportsSlice = createSlice({
  name: 'accountingReports',
  initialState,
  extraReducers: (builder) => {
    builder
      //getCorpClientReport
      .addCase(getCorpClientReport.pending, (state) => { state.getCorpClientReportStatus = 'pending'; })
      .addCase(getCorpClientReport.fulfilled, (state) => { state.getCorpClientReportStatus = 'fulfilled'; })
      .addCase(getCorpClientReport.rejected, (state) => { state.getCorpClientReportStatus = 'rejected'; })

      //getSalesReportByCorp
      .addCase(getSalesReportByCorp.pending, (state) => { state.getSalesReportByCorpStatus = 'pending'; })
      .addCase(getSalesReportByCorp.fulfilled, (state) => { state.getSalesReportByCorpStatus = 'fulfilled'; })
      .addCase(getSalesReportByCorp.rejected, (state) => { state.getSalesReportByCorpStatus = 'rejected'; })

      //getSalesReportByFiz
      .addCase(getSalesReportByFiz.pending, (state) => { state.getSalesReportByFizStatus = 'pending'; })
      .addCase(getSalesReportByFiz.fulfilled, (state) => { state.getSalesReportByFizStatus = 'fulfilled'; })
      .addCase(getSalesReportByFiz.rejected, (state) => { state.getSalesReportByFizStatus = 'rejected'; })

      //getKitchenTaxReport
      .addCase(getKitchenTaxReport.pending, (state) => { state.getKitchenTaxReportStatus = 'pending'; })
      .addCase(getKitchenTaxReport.fulfilled, (state) => { state.getKitchenTaxReportStatus = 'fulfilled'; })
      .addCase(getKitchenTaxReport.rejected, (state) => { state.getKitchenTaxReportStatus = 'rejected'; })

      //getSummarySales
      .addCase(getSummarySales.pending, (state) => { state.getSummarySalesStatus = 'pending'; })
      .addCase(getSummarySales.fulfilled, (state, action) => { state.getSummarySalesStatus = 'fulfilled'; state.summarySales = action.payload; })
      .addCase(getSummarySales.rejected, (state) => { state.getSummarySalesStatus = 'rejected'; })

      // PURGE
      .addCase(PURGE, () => initialState);
  },
  reducers: {},
});

export const {} = accountingReportsSlice.actions;

export default accountingReportsSlice.reducer;
